import React, { Component } from 'react';
import PageHeader from '../../components/pageHeader/PageHeader';
import { Col } from 'react-bootstrap';
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png';
import DeliveryGrid from '../../components/deliverygrid/DeliveryGrid';
import Footer from '../../components/footer/Footer';
import './DeliveryInfo.scss'

/**-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import PageOptimize from "../../components/SEOPageOptimize/PageOptimize";
import { withRouter } from 'react-router-dom';

// map the redux states to props
function mapStateToProps(state) {
   return {
      loadingScreenVisible: state.loadingScreen,
      responsive: state.responsive,
   }
};

// map the redux actions to props
const mapDispatchToProps = {
   showMessageBox
};


class DeliveryInfo extends Component {

   state = {
      AuthCode: false,
      imageUrlWeb: "https://essstr.blob.core.windows.net/uiimg/PageHeader/DeliveryAreas.png",
      imageUrlMobile: "https://essstr.blob.core.windows.net/uiimg/PageHeader/DeliveryAreas_M.png",
   }

   componentDidMount() {
      this.setState({
         AuthCode: (this.props.match.path.split('/')[1] === "deliveryGrid" || this.props.match.path.split('/')[1] === "mobdeliveryInfo") ? true : false
      })
   }

   render() {

      const pageHeaderImage = (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ? this.state.imageUrlMobile
         : this.state.imageUrlWeb;
      const isMobile = this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen;
      const { title, description } = this.props;
      return (
         <React.Fragment>
            <div>
               <PageOptimize title={title} description={description} />
               {/* {
                  (this.props.match.path.split('/')[1] !== "mobdeliveryInfo") ?
                     <div className='default-main-header'>
                        <Col lg={{ span: 10, offset: 0 }} md={{ span: 10, offset: 1 }} sm={{ span: 8, offset: 1 }} style={{ display: 'flex' }}>
                           <a href={`${window.location.origin}/`}>
                              <img src={KeellsLogo} className="img-fluid" />
                           </a>
                        </Col>
                     </div> :
                     <div></div>
               } */}
            </div>
            <div>
               {(!this.state.AuthCode) ?
                  <PageHeader breadcrumb='Delivery Grid' headerText="Our Delivery Areas"
                     imageUrl={pageHeaderImage} imageOnClickUrl={this.state.imageOnClickUrl} />
                  :
                  <PageHeader noCrumb={true} headerText=""
                     imageUrl={pageHeaderImage} imageOnClickUrl={this.state.imageOnClickUrl} />}



               <Col xs="12" md={{ span: 10, offset: 1 }}>
                  <DeliveryGrid />
               </Col>
            </div>
            {/* <div>
               {
                  (!this.state.AuthCode) ?
                     <Footer /> :
                     <div></div>
               }
            </div> */}
         </React.Fragment >
      )
   }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeliveryInfo));







   // </React.Fragment>
